import { render, staticRenderFns } from "./quotes-block-knowledge.vue?vue&type=template&id=ba40f4f6&scoped=true"
var script = {}
import style0 from "./quotes-block-knowledge.vue?vue&type=style&index=0&id=ba40f4f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba40f4f6",
  null
  
)

export default component.exports